import { render, staticRenderFns } from "./OrderPascabayar.vue?vue&type=template&id=662af5f5"
import script from "./OrderPascabayar.vue?vue&type=script&lang=js"
export * from "./OrderPascabayar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports